const admin_menu = [
    {
        id: 0,
        type: "title",
        title: "Menú",
        classIcon: "",
        to:"#",
        levels: 0,
    },
    {
        id: 1,
        type: "menu",
        title: "Inicio",
        classIcon: "bx bxs-box",
        to:"/",
        levels: 1,
    },
    {
        id: 2,
        type: "menu",
        title: "Areas",
        classIcon: "bx bxs-box",
        to:"/areas",
        levels: 1,
    },
    {
        id: 3,
        type: "menu",
        title: "Tipos de Bienes",
        classIcon: "bx bxs-box",
        to:"/type-properties",
        levels: 1,
    },
    {
        id: 4,
        type: "menu",
        title: "Bienes",
        classIcon: "bx bxs-box",
        to:"/properties",
        levels: 1,
    },
     {
        id: 5,
        type: "submenu",
        title: "Reportes",
        classIcon: "bx bxs-archive",
        to:"#",
        levels: 2,
        submenu:[
            {
                id: 1,
                type: "menu",
                title: "Brochure",
                classIcon: "bx bxs-book",
                to:"/brochure",
                levels: 0,
            },
            {
                id: 2,
                type: "menu",
                title: "Reporte de bienes ",
                classIcon: "bx bxs-report",
                to:"/report-properties",
                levels: 0,
            }
        ]
    },
]

const artisan_menu = [
    {
        id: 1,
        type: "title",
        title: "Menú",
        classIcon: "",
        to:"#",
        levels: 0,
    },
    {
        id: 2,
        type: "menu",
        title: "Dashboard",
        classIcon: "bx bx-calendar",
        to:"/",
        levels: 1,
    },
    {
        id: 3,
        type: "submenu",
        title: "Products",
        classIcon: "",
        to:"#",
        levels: 2,
        submenu:[
            {
                id: 1,
                type: "menu",
                title: "Listado",
                classIcon: "",
                to:"/product-list",
                levels: 0,
            },
            {
                id: 2,
                type: "menu",
                title: "Agregar Producto",
                classIcon: "",
                to:"/product-add",
                levels: 0,
            }
        ]
    },
]

const collector_menu = [
    {
        id: 1,
        type: "title",
        title: "Menú",
        classIcon: "",
        to:"#",
        levels: 0,
    },
    {
        id: 2,
        type: "menu",
        title: "Dashboard",
        classIcon: "bx bx-calendar",
        to:"/",
        levels: 1,
    },
    {
        id: 3,
        type: "menu",
        title: "Pedidos",
        classIcon: "bx bxs-box",
        to:"/order-list",
        levels: 1,
    },
]


export {admin_menu, artisan_menu, collector_menu}